module.exports = __webpack_public_path__ + "static/mattk-0a8f54182883802ba34e831287bb8be6.jpg";